import { render, staticRenderFns } from "./AppointmentsTablexUser.vue?vue&type=template&id=31f761bb&"
import script from "./AppointmentsTablexUser.vue?vue&type=script&lang=js&"
export * from "./AppointmentsTablexUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports